<twc-popup type="primary" caption="{{'PERMISSION_DIALOG.SELECT_USERS' | translate}}" width="l" #addUserPopup>
    <twc-popup-content>

        <div class="twc-row twc-mt-3">
            <div class="twc-col-12">
                <twc-list class="permissions-element-list">
                    <twc-list-item *ngFor="let user of userList"
                        [ngClass]="{'selected-row': isSelectedUserId(user.uid)}" (click)="onSelect(user.uid)">
                        <div class="twc-list-item-col-1"
                            [ngClass]="{'user-already-added': isUserAlreadyAdded(user.uid)}">
                            {{ getUserName(user.uid) }}
                        </div>
                    </twc-list-item>
                </twc-list>
            </div>
        </div>
    </twc-popup-content>

    <twc-popup-footer class="twc-mt-3">
        <button class="twc-button twc-button-link" (click)="closePopup()">
            {{'GENERAL.CLOSE' | translate}}
        </button>
        <button class="twc-button twc-ml-2 twc-button-primary" (click)="addUsers()" [disabled]="!selectedUsers.length">
            {{'PERMISSION_DIALOG.ADD' | translate}}
        </button>
    </twc-popup-footer>

</twc-popup>